/** Delivery feature flags (Model C1). Service fee: fetch via deliveryConfigService. */

// Off until DoorDash Drive partner approval is in place — see backend/delivery/config.js
// for the matching server-side kill switch (that one matters more: without it, an
// unconfigured DoorDash account silently mock-dispatches while still charging real money).
export const DELIVERY_ENABLED = false;

export const DELIVERY_FEES_LABEL = 'Delivery & fees';
